import { stripQuotedHistory, stripQuotedHtml } from './quoted-history.js';

export const AUTO_REPLY_PREFIX = '--- IT ---';

const AUTO_REPLY_MARKER = /^\s*[-–—−]{3}\s*IT\s*[-–—−]{3}/i;

export const AUTO_REPLY_SIGNATURES = Object.freeze([
  /thank you for choosing bottle of italy/i,
  /we would like to inform you that your order/i,
  /(ti|vi) informiamo che il (vostro |tuo )?ordine/i,
  /in preparazione presso il nostro magazzino/i,
  /affidat[oa] al corriere|handed over to the courier/i,
  /your (package|order) (has been|handed)/i,
  /rispondiamo in media in \d+-\d+ ore/i,
  /wir antworten im durchschnitt innerhalb von \d+-\d+/i,
  /nous répondons en moyenne dans les \d+-\d+ heures/i
]);

export function isAutoReplyText(text = '') {
  return AUTO_REPLY_MARKER.test(String(text || '').replace(/^\uFEFF/, ''));
}

function htmlToProbe(html = '') {
  return String(html || '')
    .replace(/<\s*br\s*\/?\s*>/gi, '\n')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function automationMatch(message = {}, { stripQuotes = true } = {}) {
  const text = stripQuotes ? stripQuotedHistory(message.text) : String(message.text || '');
  const html = stripQuotes ? stripQuotedHtml(message.html) : String(message.html || '');
  const probedHtml = htmlToProbe(html);
  const htmlText = stripQuotes ? stripQuotedHistory(probedHtml) : probedHtml;
  if (isAutoReplyText(text) || isAutoReplyText(htmlText)) return true;
  const haystack = `${message.subject || ''}\n${text}\n${htmlText}`;
  return AUTO_REPLY_SIGNATURES.some((pattern) => pattern.test(haystack));
}

export function hasAutomatedAuthoredContent(message = {}) {
  return message.type === 'OUTBOUND_EMAIL' && automationMatch(message);
}

export function isQuotedHistoryOnlyAutomationMatch(message = {}) {
  return message.type === 'OUTBOUND_EMAIL' && automationMatch(message, { stripQuotes: false }) && !automationMatch(message);
}

export function isAutomatedMessage(message = {}) {
  if (message.type !== 'OUTBOUND_EMAIL') return false;
  if (message.sentByUserId || message.isAutomated === false) return false;
  if (message.isAutomated === true) return true;
  return automationMatch(message);
}
